"use client";
import FuseNavigation from "@fuse/core/FuseNavigation";
import clsx from "clsx";
import { useCallback } from "react";
import useThemeMediaQuery from "@fuse/hooks/useThemeMediaQuery";
import { FuseNavigationProps } from "@fuse/core/FuseNavigation/FuseNavigation";
import { FuseNavItemType } from "@fuse/core/FuseNavigation/types/FuseNavItemType";
import useNavigationItems from "./hooks/useNavigationItems";
import { useNavbarContext } from "../navbar/contexts/NavbarContext/useNavbarContext";
import useHeaderTabs from "@/hooks/useHeaderTabs";
import { anteciparRota } from "@/configs/configRotas/criarRotaProtegida";
// --------------------------------- TYPES ---------------------------------
type NavigationProps = Partial<FuseNavigationProps>;

// -------------------------------- HELPERS --------------------------------
function anteciparItem(item: FuseNavItemType): void {
	if (item.url) void anteciparRota(item.url);
}

// ------------------------------- COMPONENT -------------------------------
function Navigation(props: Readonly<NavigationProps>) {
	// -------------------------------- STATES --------------------------------
	const { className = "", layout = "vertical", dense, active } = props;
	const { data: navigation } = useNavigationItems();
	const { closeMobileNavbar, closeNavbar } = useNavbarContext();
	const { openFromNavItem } = useHeaderTabs();

	const isMobile = useThemeMediaQuery((theme) => theme.breakpoints.down("lg"));

	// ------------------------------- HANDLERS -------------------------------
	// FuseNavigation é memoizado; manter o callback estável evita renderizar a árvore inteira.
	const handleItemClick = useCallback(
		(item: FuseNavItemType) => {
			if (!item?.url || item.disabled || item.hidden) return;

			openFromNavItem(item);
			closeNavbar();

			if (isMobile) closeMobileNavbar();
		},
		[isMobile, openFromNavItem, closeNavbar, closeMobileNavbar],
	);

	// -------------------------------- RETURN --------------------------------
	return (
		<FuseNavigation
			className={clsx("navigation flex-1", className)}
			navigation={navigation}
			layout={layout}
			dense={dense}
			active={active}
			onItemClick={handleItemClick}
			aoAnteciparItem={anteciparItem}
			checkPermission
		/>
	);
}

export default Navigation;
